import Vue from 'vue';

export function getWholesaleMergeList(data) {
  return Vue.axios({
    url: '/wholesale/merge/page',
    method: 'post',
    data,
  });
}

export function getWholesaleMergeDetail(params) {
  return Vue.axios({
    url: '/wholesale/merge/order/detail',
    params,
  });
}

export function exportWholesaleMergeList(params) {
  return Vue.axios({
    url: '/wholesale/merge/detail/export',
    responseType: 'blob',
    params,
  });
}
